module.exports = __webpack_public_path__ + "static/media/24-Viñas.4df28c52.png";